import { render } from "./OrderModal.vue?vue&type=template&id=6fd69956"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mattday/Sites/swallowdental.co.uk/app/code/SwallowDental/CustomAccount/view/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/vue/components/OrderModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fd69956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fd69956', __exports__)) {
    api.reload('6fd69956', __exports__)
  }
  
  module.hot.accept("./OrderModal.vue?vue&type=template&id=6fd69956", () => {
    api.rerender('6fd69956', render)
  })

}


export default __exports__